import { H3 } from 'platform-components';
import { UI_KIT_HEADER_TYPOGRAPHY } from 'platform-components/constants';
import React from 'react';

import LibraryBanner, { OwnProps as LibraryBannerProps } from '../library-banner/library-banner';

import './stack-cards-container.scss';

export interface Props {
    bannerProps?: LibraryBannerProps;
    children: React.ReactNode;
    titleId?: string;
}

const StackCardsContainer = (props: Props) => {
    const { bannerProps, children, titleId = 'stackCardsContainer.title' } = props;

    return (
        <div className="stack-cards-container">
            <H3 id={titleId} mix="stack-cards-container__title" typography={UI_KIT_HEADER_TYPOGRAPHY.headlineSMedium} />
            <div className="stack-cards-container__content">
                {children}
                {bannerProps && (
                    <div className="stack-cards-container__banner-wrapper">
                        <LibraryBanner
                            imageMix="stack-cards-container__banner-image"
                            textWrapperMix="stack-cards-container__banner-text-wrapper"
                            {...bannerProps}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default StackCardsContainer;
